module.exports = __webpack_public_path__ + "img/icon_support.05ad05ba.svg";